import styled from "styled-components";

const Link = styled.a`
  color: #757575;
  transition: color 0.12s ease-out 0s;
  cursor: pointer;
  text-decoration: none;
  pointer-events: none;

  &:hover {
    color: #757575;
  }
`;

export default Link;
